/**
 * <L> — thin wrapper around `useLocalisedText`. Use it to wrap any
 * user-facing string that has a US/UK spelling variant so visitors in
 * en-US regions see American spelling and everyone else keeps the
 * British form.
 *
 *   <L>Ways to honour Pelé</L>
 *   → visitors in US see:  Ways to honor Pelé
 *   → visitors in UK/AU/IN see: Ways to honour Pelé
 *
 * The child MUST be a plain string. Nested JSX is not supported —
 * split it into multiple <L> wrappers for the concrete text runs.
 */
import { useLocalisedText } from "@/lib/useEnglishLocale";

export default function L({ children }) {
  const out = useLocalisedText(typeof children === "string" ? children : String(children ?? ""));
  return out;
}
